export default function trunctate(str = '', len = 1000, symbol = '...') {
  if ((str || '').length > len) return str.slice(0, len) + symbol;
  return str || '';
}
